import 'react';
import 'prop-types';
import { Box, Text, Row, Col, AnimatedButton, Button } from 'reaxl';
import { Form, StandardZipInput } from 'reaxl-forms';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
function ZipInputForm(_ref) {
  let {
    zip,
    titleLabel,
    ctaLabel,
    onSubmit,
    className = '',
    disabled = false,
    isOfferBreakdownModal = false,
    isLoading = false
  } = _ref;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Text, {
      color: "primary",
      weight: "bold",
      size: isOfferBreakdownModal ? 300 : 400,
      children: titleLabel
    }), /*#__PURE__*/jsx("p", {
      children: "Your location will be used to calculate taxes & fees and show more accurate payments."
    }), /*#__PURE__*/jsx("div", {
      className: "margin-top-4 padding-right-2",
      children: /*#__PURE__*/jsx(Form, {
        onSubmit: onSubmit,
        children: /*#__PURE__*/jsxs(Row, {
          className: "display-flex",
          children: [/*#__PURE__*/jsx(Col, {
            xs: 4,
            children: /*#__PURE__*/jsx(StandardZipInput, {
              className: className,
              label: "ZIP Code",
              layout: "inside",
              name: "inputZip",
              id: "inputZip",
              value: zip,
              required: true,
              style: {
                minWidth: '80px'
              }
            })
          }), isOfferBreakdownModal ? /*#__PURE__*/jsx(Col, {
            xs: 8,
            children: /*#__PURE__*/jsx(AnimatedButton, {
              block: true,
              buttonState: isLoading ? 'loading' : '',
              buttonText: ctaLabel,
              "data-cmp": "getTaxesFeesBreakdownButton",
              loadedText: ctaLabel,
              type: "submit"
            })
          }) : /*#__PURE__*/jsx(Col, {
            xs: 8,
            children: /*#__PURE__*/jsx(Button, {
              block: true,
              className: className,
              type: "submit",
              disabled: disabled,
              children: ctaLabel
            })
          })]
        })
      })
    })]
  });
}
/**
 * TaxesFeesBreakdownForm component combines ZIP code input form with taxes and fees breakdown display.
 * Renders different layouts based on whether it's used in the offer breakdown modal context.
 *
 * @component
 * @param {Object} props - Component props
 * @param {string} props.zip - Current ZIP code value
 * @param {string} props.titleLabel - Title text for the ZIP input form
 * @param {string} props.ctaLabel - Label text for the submit button
 * @param {Function} [props.onSubmit=()=>{}] - Callback function when ZIP form is submitted
 * @param {Function} [props.renderTaxesFeesBreakdown=()=>{}] - Function to render the taxes and fees breakdown
 * @param {Object} [props.taxesFeesSectionProps={}] - Props passed to the breakdown renderer
 * @param {boolean} [props.isOfferBreakdownModal=false] - Whether rendered in offer breakdown modal context
 * @returns {React.ReactElement} The TaxesFeesBreakdownForm component
 */
function TaxesFeesBreakdownForm(_ref2) {
  let {
    zip,
    titleLabel,
    ctaLabel,
    onSubmit = () => {},
    renderTaxesFeesBreakdown = () => {},
    taxesFeesSectionProps = {},
    isOfferBreakdownModal = false
  } = _ref2;
  const {
    isLoading = false,
    hasError,
    taxesFees,
    showTotalTaxesOnly,
    isEstimate,
    isLease
  } = taxesFeesSectionProps || {};
  return isOfferBreakdownModal ? /*#__PURE__*/jsxs(Box, {
    backgroundColor: "neutral-secondary",
    className: "margin-top-4",
    children: [/*#__PURE__*/jsx(ZipInputForm, {
      zip: zip,
      titleLabel: titleLabel,
      ctaLabel: ctaLabel,
      onSubmit: onSubmit,
      isLoading: isLoading,
      isOfferBreakdownModal: true
    }), renderTaxesFeesBreakdown(isLoading, hasError, taxesFees, showTotalTaxesOnly, isEstimate, isLease, true)]
  }) : /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(ZipInputForm, {
      zip: zip,
      titleLabel: titleLabel,
      ctaLabel: ctaLabel,
      onSubmit: onSubmit,
      className: "margin-bottom-5"
    }), renderTaxesFeesBreakdown(isLoading, hasError, taxesFees, showTotalTaxesOnly, isEstimate, isLease)]
  });
}
export { TaxesFeesBreakdownForm as default };
